import { readable } from 'svelte/store';

export let kerst = readable([
    { id: 1,  aantalLetters: 15, significant: 1, oplossing: "tweeondereenkap" },
    { id: 2,  aantalLetters: 9,  significant: 2, oplossing: "voorkamer" },
    { id: 3,  aantalLetters: 6,  significant: 4, oplossing: "balkon" },
    { id: 4,  aantalLetters: 6,  significant: 1, oplossing: "entree" },
    { id: 5,  aantalLetters: 13, significant: 2, oplossing: "bejaardenflat" },
    { id: 6,  aantalLetters: 5,  significant: 1, oplossing: "serre" },
    { id: 7,  aantalLetters: 9,  significant: 4, oplossing: "schuifpui" },
    { id: 8,  aantalLetters: 4,  significant: 2, oplossing: "pand" },
    { id: 9,  aantalLetters: 11, significant: 2, oplossing: "" },
    { id: 10, aantalLetters: 5,  significant: 0, oplossing: "" },
    { id: 11, aantalLetters: 6,  significant: 2, oplossing: "" },
    { id: 12, aantalLetters: 11, significant: 2, oplossing: "" },
    { id: 13, aantalLetters: 5,  significant: 2, oplossing: "" },
    { id: 14, aantalLetters: 5,  significant: 3, oplossing: "" },
    { id: 15, aantalLetters: 11, significant: 4, oplossing: "bovenwoning" },
    { id: 16, aantalLetters: 11, significant: 2, oplossing: "schoorsteen" },
    { id: 17, aantalLetters: 6,  significant: 2, oplossing: "" },
    { id: 18, aantalLetters: 4,  significant: 1, oplossing: "" },
    { id: 19, aantalLetters: 11, significant: 3, oplossing: "" },
    { id: 20, aantalLetters: 5,  significant: 3, oplossing: "etage" },
    { id: 21, aantalLetters: 7,  significant: 4, oplossing: "plafond" },
    { id: 22, aantalLetters: 7,  significant: 1, oplossing: "" },
    { id: 23, aantalLetters: 11, significant: 3, oplossing: "kruipruimte" },
    { id: 24, aantalLetters: 10, significant: 3, oplossing: "verdieping" },
    { id: 25, aantalLetters: 7,  significant: 1, oplossing: "dakraam" },
    { id: 26, aantalLetters: 9,  significant: 4, oplossing: "" },
    { id: 27, aantalLetters: 8,  significant: 2, oplossing: "bungalow" },
    { id: 28, aantalLetters: 8,  significant: 2, oplossing: "voordeur" },
    { id: 29, aantalLetters: 6,  significant: 1, oplossing: "zolder" },
    { id: 30, aantalLetters: 8,  significant: 2, oplossing: "vliering" },
    { id: 31, aantalLetters: 6,  significant: 1, oplossing: "studio" },
    { id: 32, aantalLetters: 7,  significant: 3, oplossing: "drempel" },
    { id: 33, aantalLetters: 8,  significant: 2, oplossing: "" },
    { id: 34, aantalLetters: 9,  significant: 3, oplossing: "dakterras" },
    { id: 35, aantalLetters: 6,  significant: 2, oplossing: "" },
    { id: 36, aantalLetters: 4,  significant: 3, oplossing: "" },
    { id: 37, aantalLetters: 6,  significant: 3, oplossing: "" },
    { id: 38, aantalLetters: 9,  significant: 2, oplossing: "fundament" },
    { id: 39, aantalLetters: 8,  significant: 4, oplossing: "parterre" },
    { id: 40, aantalLetters: 9,  significant: 3, oplossing: "pannendak" }
]);
